import React, { Component } from 'react';

export function addStore (Comp, stores) {

	return class extends Component {
		render () {
			return <Comp { ...stores } { ...this.props } />;
		}
	}
}
